/**
 * Created by dbslab on 30/05/17.
 */

var moment = require('moment')
import configurationStore from '../../store/backoffice/configuration'

export default {
  install: function (Vue,) {
    Vue.prototype.$dateDifference = function (dateEnd, dateStart = null) {
      if (dateStart === null) {
        dateStart = moment()
      } else {
        dateStart = moment(dateStart)
      }
      var dateEnd = moment(dateEnd)
      var diffDuration = moment.duration(dateStart.diff(dateEnd))
      return diffDuration.humanize()
    }

    Vue.prototype.$dateFormat = function (date, format = null) {
      if (format == null) {
        format = this.$toMomentFormat(configurationStore.state.locale.locale_datetime_format.value)
      }
      return date ? moment(date).format(format) : null
    }

    Vue.prototype.$daysNumberToHuman = function (days) {
      if (days >= 365) {
        return 'years'
      } else {
        return 'month'
      }
      return days >= 365
    }


    Vue.prototype.$diffInDays = function (dateEnd, dateStart = null) {
      var date1 = new Date(dateStart)
      var date2 = new Date(dateEnd)
      var timeDiff = Math.abs(date2.getTime() - date1.getTime())
      return Math.ceil(timeDiff / (1000 * 3600 * 24))
    }
    Vue.prototype.$date = function (date = null) {
      return date ? moment(date) : moment()
    }

    Vue.prototype.$convertTimestamp = function (datetime) {

      if (typeof datetime === 'string') {
        var t = datetime.split(/[- :]/)
        var date = new Date(t[0], t[1] - 1, t[2], t[3], t[4])
        return Math.round(date.getTime() / 1000)
      }

      return datetime
    }

    Vue.prototype.$toMomentFormat = function (format) {
      var conversions = {
        'd': 'DD',
        'D': 'ddd',
        'j': 'D',
        'l': 'dddd',
        'N': 'E',
        'S': 'o',
        'w': 'e',
        'z': 'DDD',
        'W': 'W',
        'F': 'MMMM',
        'm': 'MM',
        'M': 'MMM',
        'n': 'M',
        't': '',
        'L': '',
        'o': 'YYYY',
        'Y': 'YYYY',
        'y': 'YY',
        'a': 'a',
        'A': 'A',
        'B': '',
        'g': 'h',
        'G': 'H',
        'h': 'hh',
        'H': 'HH',
        'i': 'mm',
        's': 'ss',
        'u': 'SSS',
        'e': 'zz',
        'I': '',
        'O': '',
        'P': '',
        'T': '',
        'Z': '',
        'c': '',
        'r': '',
        'U': 'X',
      }
      return format.replace(/[A-Za-z]+/g, function (match) {
        return conversions[match] || match
      })
    }
    Vue.prototype.$configurationDateFormat = function () {
      return configurationStore.state.locale.locale_date_format.value
    }
    Vue.prototype.$configurationDateTimeFormat = function () {
      return configurationStore.state.locale.locale_datetime_format.value
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/plugins/dates.js